import { createFileRoute, redirect } from '@tanstack/react-router'

// Back-compat redirect: the hub/list page moved to /agents-hub.
export const Route = createFileRoute('/_app/agents/')({
  beforeLoad: () => {
    throw redirect({
      to: '/agents-hub',
      replace: true,
    })
  },
})
